/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/button-has-type */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { getElectronicsTradings } from 'store/modules/monitoring_store/actions';
import { MonitoringRequestTypes, MonitoringState } from 'store/modules/monitoring_store/types';
import TradingList from 'components/molecules/trading_list';
import Loader from 'components/atoms/loader';
import { getServiceSubscriptionStatus } from 'store/modules/service_subscription_store/actions';
import ComplementaryServices from 'services/complementary_services';
import ImgSemMonitoramento from 'assets/images/sem_monitoramento_novo.png';
import tabId from 'services/tabId';
import {
  companyToRestore,
  monitoringCompanies,
  monitoringListKey,
  monitoringSubscriptionCompany,
} from 'services/monitoring_companies';
import { ProfileState, ProfileTypes } from 'store/modules/profile_store/types';
import { Container } from './styles';

const Monitoring = () => {
  const DEFAULT_PAGE = 1;
  const DEFAULT_SOURCE_ID = 0;
  const { monitoring, request } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const dispatch = useDispatch();

  const [isTradingMessage, setIsTradingMessage] = useState<boolean>(true);
  const [search, setSearch] = useState<string | null>(null);
  const [activeFilter, setActiveFilter] = useState<'all' | 'important' | 'archived' | 'unread'>(
    'all',
  );

  const urlCompany = useRef<number | null>(
    Number(new URLSearchParams(window.location.search).get('company_id')) || null,
  );
  const lastRequest = useRef('');

  const companyId = () => {
    tabId();
    if (!profile.representant) return profile.clientId;

    const fromUrl = urlCompany.current;
    if (!fromUrl) return profile.currentCompany[tabId()];

    urlCompany.current = null;
    dispatch({
      type: ProfileTypes.UPDATE_CURRENT_COMPANY,
      tabId: tabId(),
      companyId: fromUrl,
    });

    return fromUrl;
  };

  const activeCompany = profile.representant ? profile.currentCompany[tabId()] : profile.clientId;

  const profileRef = useRef(profile);
  profileRef.current = profile;

  useEffect(
    () => () => {
      const restore = companyToRestore(profileRef.current);
      if (restore === null) return;

      dispatch({ type: ProfileTypes.UPDATE_CURRENT_COMPANY, tabId: tabId(), companyId: restore });
    },
    [],
  );
  const listKey = monitoringListKey(monitoringCompanies(profile, activeCompany), activeCompany);

  const isGlobalEmpty =
    request.electronics_tradings.loaded &&
    !request.electronics_tradings.loading &&
    monitoring.electronics_tradings_total_entries === 0 &&
    !search &&
    activeFilter === 'all';

  useEffect(() => {
    document.title = 'Monitorar Chat - ConLicitação';

    dispatch({ type: MonitoringRequestTypes.UPDATE_STORE_FIELDS });
    const monitoringServiceId = ComplementaryServices.find(
      (complementaryService) => complementaryService.name === 'Monitoring',
    )?.id;

    if (!monitoringServiceId) return;

    dispatch(
      getServiceSubscriptionStatus(monitoringServiceId, monitoringSubscriptionCompany(profile)),
    );
  }, []);

  useEffect(() => {
    dispatch({ type: MonitoringRequestTypes.UPDATE_CURRENT_PAGE, page: DEFAULT_PAGE });
    dispatch({
      type: MonitoringRequestTypes.UPDATE_CURRENT_SOURCE_ID,
      sourceId: DEFAULT_SOURCE_ID,
    });
  }, [monitoring?.filtered_by]);

  useEffect(() => {
    const company = companyId();
    const params = {
      page: monitoring?.current_page,
      source_id: monitoring?.current_source_id,
      filtered_by: monitoring?.filtered_by,
      companyId: company,
      companyIds: monitoringCompanies(profile, company),
      filter_type: activeFilter,
      search,
    };
    const requestKey = JSON.stringify(params);
    if (profile.representant && requestKey === lastRequest.current) return;

    lastRequest.current = requestKey;
    dispatch(getElectronicsTradings(params));
  }, [
    monitoring?.current_page,
    monitoring?.current_source_id,
    monitoring?.filtered_by,
    listKey,
    activeFilter,
    search,
  ]);

  return (
    <Container>
      <div className="container-fluid p-0">
        {request.electronics_tradings.loading && monitoring.electronics_tradings?.length === 0 && (
          <Loader />
        )}

        {isGlobalEmpty ? (
          <div className="row justify-content-center align-items-center pt-5">
            <div className="col-md-2">
              <img src={ImgSemMonitoramento} className="w-100 mb-2" alt="Sem pregões monitorados" />
            </div>
            <div className="col-md-4">
              <h4 className="pb-3 mt-4">Você ainda não ativou nenhuma licitação para monitorar.</h4>
              <p>Veja como é fácil ativar a função Monitorar Chat:</p>
              <p>
                1. Acesse <a href="/boletim_web/public/boletins">Boletins de Licitações</a>,{' '}
                <a href="/banco_de_dados">Encontrar Licitações</a> ou{' '}
                <a href="/minhas_licitacoes/biddings">Gerenciar Licitações.</a>
              </p>
              <p>
                2. Encontre uma licitação com o botão &quot;Ativar monitoramento de chat&quot; e
                clique nele.
              </p>
              <p>3. Pronto! Agora é só acompanhar o chat da licitação no menu Monitorar Chat.</p>
            </div>
          </div>
        ) : (
          <TradingList
            isTradingMessage={isTradingMessage}
            setIsTradingMessage={setIsTradingMessage}
            search={search}
            setSearch={setSearch}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
      </div>
    </Container>
  );
};

export default Monitoring;
